module.exports = __webpack_public_path__ + "static/media/creador-pdf-departamentos.2ef9fdc7.JPG";